import React from "react";

function Color_Mixer() {
  return (
    <div>
      <h1>Color_Mixer Component</h1>
      <p>This is the Color Mixer tutorial page content.</p>
    </div>
  );
}

export default Color_Mixer;
